import React from "react";
import { stepStyles } from "./formStyles";

export const Address = ({ formData, setForm, navigation }) => {
  const { address, city, state, zip } = formData;
  return (
    <div className={stepStyles.page}>
      <div className={stepStyles.content}>
        <div className={stepStyles.panel}>
          <h1 className={stepStyles.title}>What is your address?</h1>
          <div className={stepStyles.fieldStack}>
            <div className={stepStyles.fieldRow}>
              <div className="w-full md:w-auto">
                <input
                  name="address"
                  value={address}
                  onChange={setForm}
                  id="address"
                  className={stepStyles.input}
                  placeholder="123 Main St"
                />
              </div>
              <label htmlFor="address" className={stepStyles.fieldLabel}>
                Address
              </label>
            </div>
            <div className={stepStyles.fieldRow}>
              <div className="w-full md:w-auto">
                <input
                  name="city"
                  value={city}
                  onChange={setForm}
                  id="city"
                  className={stepStyles.input}
                  placeholder="City"
                />
              </div>
              <label htmlFor="city" className={stepStyles.fieldLabel}>
                City
              </label>
            </div>
            <div className={stepStyles.fieldRow}>
              <div className="w-full md:w-auto">
                <input
                  name="state"
                  value={state}
                  onChange={setForm}
                  id="state"
                  className={stepStyles.input}
                  placeholder="State"
                />
              </div>
              <label htmlFor="state" className={stepStyles.fieldLabel}>
                State
              </label>
            </div>
            <div className={stepStyles.fieldRow}>
              <div className="w-full md:w-auto">
                <input
                  name="zip"
                  type="number"
                  value={zip}
                  onChange={setForm}
                  id="zip"
                  className={stepStyles.input}
                  placeholder="Zip"
                />
              </div>
              <label htmlFor="zip" className={stepStyles.fieldLabel}>
                Zip
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <button className={`${stepStyles.buttonAlt} w-full md:w-auto`} onClick={() => navigation.previous()}>
            Back
          </button>
          <button className={`${stepStyles.button} w-full md:w-auto`} onClick={() => navigation.next()}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
